var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconEmailSimple(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 11"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.892 5.62a.381.381 0 01-.033.02l-.009.004a.374.374 0 01-.077.029H7.77a.374.374 0 01-.041.007c-.002 0-.004.008-.006.008a.408.408 0 01-.043.012.408.408 0 01-.04-.01c-.003 0-.004-.004-.006-.004a.384.384 0 01-.04-.01l-.004-.001a.378.378 0 01-.077-.03l-.008-.004a.211.211 0 01-.03-.018h-.002L7.47 5.62.19.771a1.48 1.48 0 00-.19.725v7.628a1.5 1.5 0 001.492 1.496h12.376a1.5 1.5 0 001.492-1.496V1.496c0-.289-.084-.571-.243-.813L7.894 5.618l-.002.001z",
    fill: "#0A3F46"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.544.165A1.48 1.48 0 0013.867 0H1.492C1.22 0 .951.076.718.22l6.96 4.636L14.544.165z",
    fill: "#0A3F46"
  })));
}

export default SvgIconEmailSimple;